<template>
  <AppTextButton
    :route="{
      name: 'memberships',
    }"
    class="memberships-button mx-auto mt-3 w-full"
    variant="primary"
    :label="$t('button.see.join_now')"
    icon="ArrowRight"
  />
</template>
